const r = {
  baseStyle: ({ theme: e }) => ({
    ...e.priceText
  }),
  variants: {
    regular: ({ theme: e }) => ({
      color: e.text.default
    }),
    onSale: ({ theme: e }) => ({
      color: e.text.sale
    }),
    wasPrice: ({ theme: e }) => ({
      color: e.text.deemphasized,
      textDecoration: e.strikethrough,
      paddingLeft: e.sp02,
      ...e.priceWasText
    })
  },
  defaultProps: {
    variant: "regular"
  }
}, t = {
  baseStyle: ({ theme: e }) => ({
    ...e.priceText
  }),
  variants: {
    regularPrice: ({ theme: e }) => ({
      color: e.text.default
    }),
    salePrice: ({ theme: e }) => ({
      color: e.text.sale,
      paddingRight: e.element.spacingSmall
    }),
    wasPrice: ({ theme: e }) => ({
      ...e.priceWasText,
      color: e.text.deemphasized,
      textDecoration: e.strikethrough
    }),
    mopRegPrice: ({ theme: e }) => ({
      color: e.text.sale,
      paddingRight: e.element.spacingSmall
    }),
    nonMembersPrice: ({ theme: e }) => ({
      ...e.priceTextSmall,
      color: e.text.default,
      paddingRight: e.element.spacingSmall
    }),
    nonMembersWasPrice: ({ theme: e }) => ({
      ...e.priceWasTextSmall,
      color: e.text.deemphasized,
      textDecoration: e.strikethrough
    }),
    priceDescriptorDeal: ({ theme: e }) => ({
      ...e.dealBadgeText,
      color: e.text.deal
    }),
    priceDescriptorNonMembers: ({ theme: e }) => ({
      ...e.dealBadgeText,
      color: e.text.default
    })
  },
  defaultProps: {
    variant: "regular"
  }
};
export {
  t as PriceTextDeal,
  r as default
};
